<template>
  <div class="label-item">
    <span class="label" v-if="label != ''">{{label}}</span>
    <span class="text">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'LabelItem',

  props: {
    label: {
      type: String,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.label-item{
  display: flex;
  flex-direction: column;
  text-align: left;
  .label{
    font-family: $notoSans;
    font-size: 14px;
    line-height: 23.4px;
    color: $white;
  }
  .text{
    margin-top: 5px;
    font-family: $notoSans;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.8;
    color: $white;
    border-radius: 8px;
    padding: 4px 10px;
    background-color: $lightColor;
    min-height: 40px;
  }
}
</style>
